/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2021
 * @format
 * @flow
 */

import { ActionTypes } from '../constants';

export function addPrintLog(log) {
  return {
    type: ActionTypes.ADD_PRINT_LOG,
    payload: { log },
  };
}

export function clearPrintLog() {
  return {
    type: ActionTypes.ADD_PRINT_LOG,
    payload: {},
  };
}
